import api from './baseApi';
import type { ListMasksDto, MaskDto, RegisterMaskDto } from './typings/mask';

const controller = '/Mask';

export const getDefaultMasks = (): Promise<MaskDto[]> =>
    api.get<MaskDto[]>(`${controller}/Defaults`).then(({ data }) => data);

export const getUserMasks = (page: number, pageSize: number): Promise<ListMasksDto> =>
    api
        .get<ListMasksDto>(controller, { params: { page, pageSize } })
        .then(({ data }) => data);

export const registerMask = (mask: RegisterMaskDto): Promise<MaskDto> =>
    api.post<MaskDto>(controller, mask).then(({ data }) => data);
